const languages = [
    { value: 'en', label: 'English' },
    { value: 'de', label: 'German' },
    { value: 'es', label: 'Spanish' },
    { value: 'fr', label: 'French' },
    { value: 'th', label: 'Thai' },
    { value: 'no', label: 'Norwegian'},
    { value: 'vi', label: 'Vietnamese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'bn', label: 'Bengali' },
    { value: 'ru', label: 'Russian' },
    { value: 'pt', label: 'Portuguese' },
    { value: 'id', label: 'Indonesian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'tr', label: 'Turkish' },
    { value: 'ko', label: 'Korean' },  
    { value: 'sv', label: 'Swedish' },        
    { value: 'uk', label: 'Ukrainian' },
    { value: 'it', label: 'Italian' },
    { value: 'zh', label: 'Chinese' },
    { value: 'hi', label: 'Hindi' },
    { value: 'fa', label: 'Farsi' },
    { value: 'cs', label: 'Czech'},
    { value: 'pl', label: 'Polish' },
    { value: 'nl', label: 'Dutch' },
    { value: 'ro', label: 'Romanian' },
    { value: 'bg', label: 'Bulgarian' },
    { value: 'hg', label: 'Hungarian' },
    { value: 'da', label: 'Danish' },
    { value: 'et', label: 'Estonian' },
    { value: 'gr', label: 'Greek' },
    { value: 'lt', label: 'Lithuanian' },
    { value: 'lv', label: 'Latvian' },
    { value: 'he', label: 'Hebrew' }
];

const findLanguageByShortCode = shortcode =>
    languages.find(language => language.value === shortcode);

export { languages, findLanguageByShortCode };